import React, { useState } from 'react'
import { CloseIcon, FilterIcon, SwapGrayIcon, SwapIcon, filterBlackIcon } from '../../../../assets/images';
import { ButtonDropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { RadioContainer } from '../../../commons';
import { RadioTypes } from '../../../../commonTypes/universalTypes';

const RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "Recently Added First",
    name: "Recently Added First"
  },
  {
    id: "Employee Name A to Z",
    name: "Employee Name - A to Z"
  },
  {
    id: "Employee Name Z to A",
    name: "Employee Name - Z to A"
  },
]

type SortByUserName={
  name:string,
  value:string
}

type AppProps = {
  setSortByUserName:any;
  sortByUserName:SortByUserName;
  startDate: string;
  endDate: string;
}

const AvailabilityReportSorting = ({
  setSortByUserName,
  sortByUserName,
  startDate,
  endDate,
 }: AppProps) => {

  const [toggle, setToggle] = useState<boolean>(false);

  const handleRadioValue = (data: any) => {
    if(data==="Recently Added First"){
      setSortByUserName({
        name:"Recently Added First",
        value:""
      })
    }
    else if(data==="Employee Name A to Z"){
      setSortByUserName({
        name:"Employee Name A to Z",
        value:"asc"
      })
    }
    else if(data==="Employee Name Z to A"){
      setSortByUserName({
        name:"Employee Name Z to A",
        value:"desc"
      })
    }
  }
  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        setToggle(startDate?.length && endDate?.length ? !toggle : toggle);
      }}
    >
      <OverlayTrigger
        placement="bottom"
        delay={{ show: 250, hide: 250 }}
        overlay={
          <Tooltip id="button-view-download-invoice">
            Sorting
          </Tooltip>
        }
      >
        <DropdownToggle
          caret
          color="secondary"
          style={{ 
            border: "1px solid#bfcbe1",
            backgroundColor: !startDate?.length || !endDate?.length ? "#d3d3d3" : "white"
           }}
          outline
          toggle={() => {
            setToggle(!toggle);
          }}
        >
          <img
            src={sortByUserName?.value ? SwapIcon:SwapGrayIcon}
            alt=""
          />
        </DropdownToggle>
      </OverlayTrigger>
      <DropdownMenu
        right
        style={{ width: "340px", padding: "15px 15px 15px" }}
      >
        <div className="d-flex justify-content-between mt-0 mb-0">
          <h5 className="text-center ">Sort</h5>
          <div
            className="pointer"
            onClick={() => {
              setToggle(!toggle);
            }}
          >
            <img
              src={CloseIcon}
              alt=""
            />
          </div>
        </div>
        <hr className="mt-0 mb-0" />
        <div className="row d-block p-3">
          <div>
            <RadioContainer
              optionsList={RADIO_OPTIONS}
              handleSetRadioValue={handleRadioValue}
              radioValue={
                sortByUserName?.name
                  ? sortByUserName?.name
                    : "Recently Approved First"
              }
              alignment="vertical"
              backGround={true}
            />
          </div>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  )
}

export default AvailabilityReportSorting